<template>
  <div />
</template>

<script>
export default {
  name: "AuthCallback",
  created() {},
};
</script>

<style scoped>
</style>
